import { differenceInDays, format, parse } from "date-fns";
import { TransactionOrderType } from "../constants";
import {
  TransactionOrder,
  XSIPTransactionOrder,
  SwpTransactionOrder,
  StpTransactionOrder,
  RedemptionTransactionOrder,
  Plan,
  STPPlan,
  SWPPlan,
  SIPPlan,
  PlanFrequency,
  SwitchTransactionOrder,
  PurchaseTransactionOrder,
} from "../types";

export function getOrderName(order: TransactionOrder) {
  let orderName = "";
  if (order.type === "SWITCH" || order.type === "STP") {
    orderName = `${order.switch_out_scheme_name} → ${order.switch_in_scheme_name}`;
  } else {
    orderName = order.scheme_name;
  }
  return orderName;
}

export function isPurchaseOrder(
  order?: TransactionOrder | null
): order is PurchaseTransactionOrder {
  return Boolean(order && order.type === TransactionOrderType.PURCHASE);
}

export function isSIPOrder(
  order?: TransactionOrder | null
): order is XSIPTransactionOrder {
  return Boolean(order && order.type === TransactionOrderType.XSIP);
}

export function isSWPOrder(
  order?: TransactionOrder | null
): order is SwpTransactionOrder {
  return Boolean(order && order.type === TransactionOrderType.SWP);
}

export function isSTPOrder(
  order?: TransactionOrder | null
): order is StpTransactionOrder {
  return Boolean(order && order.type === TransactionOrderType.STP);
}

export function isRecurringOrder(
  order?: TransactionOrder | null
): order is XSIPTransactionOrder | SwpTransactionOrder | StpTransactionOrder {
  return isSIPOrder(order) || isSWPOrder(order) || isSTPOrder(order);
}

export function isRedemptionOrder(
  order?: TransactionOrder | null
): order is RedemptionTransactionOrder {
  return Boolean(order && order.type === TransactionOrderType.REDEMPTION);
}

export function isSwitchOrder(
  order?: TransactionOrder | null
): order is SwitchTransactionOrder {
  return Boolean(order && order.type === TransactionOrderType.SWITCH);
}

export function isSipPlan(plan: Plan): plan is SIPPlan {
  return "scheme_name" in plan;
}

export function isSwpPlan(plan: Plan): plan is SWPPlan {
  return "number_of_withdrawals" in plan;
}

export function isStpPlan(plan: Plan): plan is STPPlan {
  return "switch_in_scheme_id" in plan;
}

export function getPlanStartDate(
  value: string,
  minDate: string,
  frequency: PlanFrequency
) {
  const startDate = parse(value, "yyyy-MM-dd", new Date());
  startDate.setHours(0, 0, 0, 0);
  if (!minDate) return format(startDate, "yyyy-MM-dd");
  while (differenceInDays(startDate, minDate) < 0) {
    if (frequency === "MONTHLY") {
      startDate.setMonth(startDate.getMonth() + 1);
    } else if (frequency === "DAILY") {
      startDate.setDate(startDate.getDate() + 1);
    } else if (frequency === "WEEKLY") {
      startDate.setDate(startDate.getDate() + 7);
    } else {
      break;
    }
  }
  return format(startDate, "yyyy-MM-dd");
}
